import React from "react";

import styles from "./DeliveryCost.module.scss";

const DeliveryCost: React.FC = () => {
  return (
    <section className={styles.deliveryCost}>
      <div className="container">
        <div className={styles.body}>
          <div className={styles.item}>
            <h3>
              Индивидуальный расчет
              <img src="/img/main/delivery-and-payment/divider.svg" alt="line" />
            </h3>
            <p className={styles.text}>
              Стоимость доставки рассчитывается индивидуально согласно тарифам выбранного вами вида отправления, а также
              габаритов, веса, удалённости населённого пункта.
            </p>
          </div>
          <div className={styles.item}>
            <h3>
              Ориентировочная сумма
              <img src="/img/main/delivery-and-payment/divider.svg" alt="line" />
            </h3>
            <p className={styles.text}>
              При оформлении заказа менеджер может сказать вам примерную стоимость, но точная сумма будет известна только
              после окончательного формирования заказа и упаковки.
            </p>
          </div>
          <div className={styles.item}>
            <h3>Варианты отправки</h3>
            <p className={styles.text}>
              После того как все детали будут учтены, менеджер рассчитает стоимость отправления разными способами, и вы сможете
              выбрать более приоритетный/выгодный для вас.
            </p>
          </div>
        </div>
        <div className={styles.warning}>
          <div className={styles.info}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.5001 8.99979V13.9998M12.5001 21.4098H6.44005C2.97005 21.4098 1.52005 18.9298 3.20005 15.8998L6.32006 10.2798L9.26006 4.99979C11.0401 1.78979 13.9601 1.78979 15.7401 4.99979L18.6801 10.2898L21.8001 15.9098C23.4801 18.9398 22.0201 21.4198 18.5601 21.4198H12.5001V21.4098Z"
                stroke="#1C1D20"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M12.495 17H12.504" stroke="#1C1D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <h3>
              Отправка посылки осуществляется при полной оплате заказа и стоимости пересылки. Наложенным платежом не работаем.
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeliveryCost;
